module.exports = __webpack_public_path__ + "img/位图备份_15.863f7ec2.jpg";